import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="utils--autofocus"
export default class extends Controller {
  connect() {
    this.element.focus()
   }
}
